var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',[_vm._v("开通"+_vm._s(_vm.payWay === 10 ? '微信' : '支付宝')+"收款")]),(_vm.activeStep === 1)?_c('apply-for-activation'):_c('merchant-authentication')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }